import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import AlgorithmSelection from "./pages/AlgorithmSelection"; // Import the Algorithm Selection page
import AnalysisSelection from "./pages/AnalysisSelection";
import AutoMLPage from "./pages/AutoMLPage";
import Dashboard from "./pages/Dashboard";
import DatasetPreview from "./pages/DatasetPreview";
import Home from "./pages/Home";
import Login from "./pages/Login";
import React from "react";
import Register from "./pages/Register";
import Results from "./pages/Results";
import SplitLanding from "./pages/SplitLanding";
import SupervisedPage from "./pages/SupervisedPage"; // Placeholder for Supervised
import UnsupervisedAlgorithmSelection from "./pages/UnsupervisedAlgorithmSelection";
import UnsupervisedPage from "./pages/UnsupervisedPage"; // Placeholder for Unsupervised
import UnsupervisedResults from "./pages/UnsupervisedResults";
import PredictiveAnalysis from "./pages/PredictiveAnalysis";

function App() {
  return (
    <Router>
      <Routes>
        {/* Split Landing Page */}
        <Route path="/" element={<SplitLanding />} />
        
        {/* MyAi Home Page */}
        <Route path="/myai" element={<Home />} />

        {/* Authentication */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* User Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* AutoML */}
        <Route path="/auto-ml" element={<AutoMLPage />} />

        {/* Dataset Preview */}
        <Route path="/dataset-preview" element={<DatasetPreview />} />

        <Route path="/analysis-selection" element={<AnalysisSelection />} />

        {/* Supervised and Unsupervised Learning */}
        <Route path="/supervised" element={<SupervisedPage />} />
        <Route path="/unsupervised" element={<UnsupervisedPage />} />

        {/* Algorithm Selection */}
        <Route path="/algorithm-selection" element={<AlgorithmSelection />} />
        <Route path="/unsupervised-algorithm-selection" element={<UnsupervisedAlgorithmSelection />} />

        {/* Results */}
        <Route path="/results" element={<Results />} />
        <Route path="/unsupervised-results" element={<UnsupervisedResults />} />
        
        {/* Predictive Analysis */}
        <Route path="/predict" element={<PredictiveAnalysis />} />

      </Routes>
    </Router>
  );
}

export default App;
